import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {RESTAnalyticsDashboardLayoutRow} from 'insights/layouts/RESTLayoutTypes';

import {GraphQLLayoutRowSpec} from './__generated/GraphQLLayoutRowSpec';

const GRAPHQL_ANALYTICS_QUERY_SPEC_FRAGMENT: DocumentNode = gql`
  fragment GraphQLLayoutRowSpec on AnalyticsDashboardLayoutRowNode {
    analyticsQueries {
      id
    }
  }
`;

export const GraphQLLayoutRowSpecFragment: FragmentWrapper<GraphQLLayoutRowSpec> = {
  fragment: GRAPHQL_ANALYTICS_QUERY_SPEC_FRAGMENT,
  fragmentName: 'GraphQLAnalyticsQuerySpec',
};

export function convertGQLToRESTLayoutRow(
  gqlLayoutRow: GraphQLLayoutRowSpec
): RESTAnalyticsDashboardLayoutRow {
  return {
    analyticsQueryIds: gqlLayoutRow.analyticsQueries.map((query) => query.id),
  };
}

export function convertRESTToGQLLayoutRow(
  restAnalyticsQuery: RESTAnalyticsDashboardLayoutRow
): GraphQLLayoutRowSpec {
  return {
    __typename: 'AnalyticsDashboardLayoutRowNode',
    analyticsQueries: restAnalyticsQuery.analyticsQueryIds.map((queryId) => ({
      __typename: 'AnalyticsQueryNode',
      id: queryId,
    })),
  };
}
